import { classNames } from "../../utils"
import { Flex, type FlexProps } from "../Flex/Flex"

export type FlexCenterProps = FlexProps

export function FlexCenter({ className, ...rest }: FlexCenterProps) {
  return <Flex className={classNames("items-center", className)} {...rest} />
}
